// ==========================================
// Detect window breakpoints
// ==========================================

import * as R from 'ramda'

import { isBrowser } from './dom'
const breakpoints = {
  lg: 1024,
  xl: 1280,
  xxl: 1536,
  small: 580,
  compact: 960,
  narrow: 1260,
  wide: 1440,
  tablet: 1080
}

// (breakpoint: Number, max: Boolean) => Boolean
export const atBreakpoint = (breakpoint, max = false) => {
  const compare = max ? R.lt : R.gte
  return isBrowser && compare(window.innerWidth, breakpoint)
}

export default breakpoints
